import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import {
    addAndApplyFilter,
    removeAndApplyFilter,
    clearFiltersByName,
    updateUriRef,
} from '../../../actions/filterActions';
import { trackFilterChange } from '../../../utils/tracking/searchBrowse/filterTracking';

// components
import { SbSharedRefineMenuInputRadio } from '../SbSharedRefineMenuInput/SbSharedRefineMenuInputRadio';

// Used just for identifying the `all` value, should never be set in the filter store.
function getAllUrlLabel(filterName) {
    return `all ${filterName}`;
}

const { all } = defineMessages({
    all: {
        id: 'sb.SbMobileRefineMenu.radioSelect.all',
        defaultMessage: `{filterName, select,
            location {Anywhere}
            categoryL2 {All {allLabel}}
            categoryL3 {All {allLabel}}
            categoryL4 {All {allLabel}}
            price {Any price}
            priceTrade {Any price}
            other {All}
        }`,
    },
});

function SbSharedRefineMenuRadioSelectComponent(props) {
    const {
        appliedFilterValues,
        valuesToShow,
        filterName,
        intl,
        displayUriRef,
        canBeDismissed,
        allLabel,
        totalCount,
        currency,
    } = props;
    const allUrlLabel = getAllUrlLabel(filterName);
    const appliedUrlLabel = get(appliedFilterValues, '0.urlLabel') || allUrlLabel;
    const valuesToShowCopy = [...valuesToShow];

    if (canBeDismissed && valuesToShow.length > 1) {
        valuesToShowCopy.unshift({
            displayName: intl.formatMessage(all, { filterName, allLabel }),
            urlLabel: allUrlLabel,
            count: totalCount || 0,
            link: displayUriRef,
            currency,
        });
    }

    return (
        <div>
            {valuesToShowCopy.map(item => {
                return (
                    <SbSharedRefineMenuInputRadio
                        key={item.urlLabel}
                        value={item.urlLabel}
                        checked={item.urlLabel === appliedUrlLabel}
                        seoLink={item.link}
                        onChange={() => props.onChange(item)}
                        text={item.displayName}
                        count={item.count}
                        isHidden={item.isHidden}
                    />
                );
            })}
        </div>
    );
}

SbSharedRefineMenuRadioSelectComponent.propTypes = {
    appliedFilterValues: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    displayUriRef: PropTypes.string.isRequired,
    valuesToShow: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    canBeDismissed: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    allLabel: PropTypes.string,
    totalCount: PropTypes.number,
    currency: PropTypes.string,
};

function mapDispatchToProps(dispatch, { filterName }) {
    return {
        onChange(item) {
            const currency = get(item, 'currency');
            dispatch(clearFiltersByName(filterName));
            if (item.urlLabel !== getAllUrlLabel(filterName)) {
                if (currency) {
                    dispatch(
                        addAndApplyFilter('currency', {
                            urlLabel: currency.toLowerCase(),
                        })
                    );
                }
                dispatch(addAndApplyFilter(filterName, item));
            } else {
                if (currency) {
                    dispatch(
                        removeAndApplyFilter('currency', {
                            urlLabel: currency.toLowerCase(),
                        })
                    );
                }
                trackFilterChange({ filterName, filterValue: item });
                dispatch(updateUriRef());
            }
        },
    };
}

export const SbSharedRefineMenuRadioSelect = connect(
    null,
    mapDispatchToProps
)(injectIntl(SbSharedRefineMenuRadioSelectComponent));
